module.exports = __webpack_public_path__ + "static/media/icn_select_drop.06eb03b2.svg";